import { combineReducers } from 'redux';
import send from './send';

export default combineReducers({
  send,
});
